export default __webpack_public_path__ + "static/media/truck-no-logo.90e26857.svg";